const creative = {
  search: {
    web: '212X212_M-C-IG_TI-1_4-4_Search_Web',
    mobile: '91X91_M-R-IG_TI-1_2-2_Search_Mobile'
  },
  browse: {
    web: '750x392_T-C-IG_TI-2_3-3_Browse_web',
    mobile: '375x180_M-C-IG_TI-1_1-3_Browse_Mobile'
  },
  canned: {
    web: '375x180_M-C-IG_TI-1_1-3_Event_Desktop',
    mobile: '375x180_M-C-IG_TI-1_1-3_Event_Mobile'
  }
}

const defaultParams = {
  hlpt: 'S',
  beacon: 'individual',
  apiKey: 'D3B53863-2511-4DCE-9CD6-DE1F7C02201A',
  verbosity: 'default'
}

const constructQueryString = function constructQueryString(params) {
  const allParams = { ...defaultParams, ...params }

  return Object.keys(allParams)
    .reduce(function(queryParams, key) {
      allParams[key] !== null && allParams[key] !== false && queryParams.push(`${key}=${allParams[key]}`)
      return queryParams
    }, [])
    .join('&')
}

const getMinMaxParamsObject = platform => {
  const minMaxParams = {
    mobile: {
      minmes: 1,
      maxmes: 2
    },
    web: {
      minmes: 3,
      maxmes: 3
    }
  }
  return minMaxParams[platform]
}

export const getHookLogicUrl = (payload, userId, platform, pageType) => {
  const hookLogicPath = `/monetisation-api/delivery/api/${payload.taxonomy ? 'taxonomy' : 'search'}?`
  const params = monetisationParams(payload, userId, platform, pageType)
  return `${hookLogicPath}${constructQueryString(params)}`
}

export const getCitrusUrl = (payload, userId, platform) => {
  const citrusUrl = `${window.citrusEndpoint}/delivery/api/${payload.taxonomy ? 'taxonomy' : 'search'}?`
  const params = monetisationParams(payload, userId, platform)
  const authParams = {
    teamId: window.citrusTeamId,
    catalogId: window.citrusCatalogId,
    apiKey: window.citrusKey
  }
  Object.assign(params, authParams)
  return `${citrusUrl}${constructQueryString(params)}`
}

const monetisationParams = (payload, userId, platform, pageType = '') => {
  const params = {
    ...payload,
    puserid: userId,
    platform,
    creative: creative.search[platform],
    ...getMinMaxParamsObject(platform)
  }
  if (payload.taxonomy) {
    return Object.assign(params, {
      hlpt: 'B',
      taxonomy: payload.taxonomy,
      creative: pageType && pageType === 'canned' ? creative.canned[platform] : creative.browse[platform]
    })
  }
  return params
}
